import { useMutation } from '@tanstack/react-query';
import { repo } from 'index';

export const useLicensePlateDelete = () => {
  const { mutateAsync, status, isLoading } = useMutation({
    mutationFn: repo.deleteLicensePlate,
  });

  return {
    deleteLicensePlateMutateAsync: mutateAsync,
    deleteLicensePlateStatus: status,
    isLicensePlateDeleteLoading: isLoading,
  };
};
